import { Component, ElementRef, OnInit, Output, ViewChild } from '@angular/core';
import { GestureController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-drawer',
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
})
export class DrawerComponent {

  @ViewChild('drawer', { read: ElementRef}) drawer: ElementRef;

  isOpen = false;

  constructor(private plt: Platform, private gestureCtrl: GestureController) { }

  toggleDrawer() {
    const drawer = this.drawer.nativeElement;

    if(this.isOpen) {
      drawer.style.transition = '.4s ease-out';
      drawer.style.bottom = 'calc(-50vh + 40px)';
      this.isOpen = false;
    } else {
      drawer.style.transition = '.4s ease-out';
      drawer.style.bottom = `0`;
      this.isOpen = true;
    }
  }

}
